import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Card, Typography, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import GroupIcon from '@mui/icons-material/Group';
import LogoutIcon from '@mui/icons-material/Logout';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledCard = styled(Card)(({ _theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(400px, 90vw)',
  padding: '24px',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  borderRadius: '16px',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
  backdropFilter: 'blur(8px)',
  border: '1px solid rgba(255, 255, 255, 0.18)',
  zIndex: 1000,
  animation: `${fadeIn} 0.3s ease-out`,
}));

const Backdrop = styled(Box)(({ _theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(5px)',
  zIndex: 999,
}));

const StyledListItem = styled(ListItem)(({ _theme }) => ({
  borderRadius: '8px',
  marginBottom: '8px',
  padding: '12px 16px',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    transform: 'translateX(4px)',
  },
}));

const CenteredNavCard = ({ onClose, handleLogout }) => {
  return (
    <>
      <Backdrop onClick={onClose} />
      <StyledCard>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Navigation</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          <StyledListItem button component={Link} to="/settings" onClick={onClose}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </StyledListItem>
          <StyledListItem button component={Link} to="/pos-management" onClick={onClose}>
            <ListItemIcon>
              <PointOfSaleIcon />
            </ListItemIcon>
            <ListItemText primary="POS Management" />
          </StyledListItem>
          <StyledListItem button component={Link} to="/user-management" onClick={onClose}>
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText primary="User Management" />
          </StyledListItem>
          <StyledListItem button component={Link} to="/item-forwarders" onClick={onClose}>
            <ListItemIcon>
              <SwapHorizIcon />
            </ListItemIcon>
            <ListItemText primary="Item Forwarders" />
          </StyledListItem>
          <StyledListItem button onClick={() => { handleLogout(); onClose(); }}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </StyledListItem>
        </List>
      </StyledCard>
    </>
  );
};

export default CenteredNavCard;
